export default __webpack_public_path__ + "static/media/logo.9c834c4f.png";